import {Component} from '@angular/core';
import {Compbaser} from "../../../components/compbaser";
import {FintechService} from "../../../services/fintech.service";
import {ActivatedRoute} from "@angular/router";
import {of} from "rxjs";


@Component({
    templateUrl: './subscriber.component.html',
    styleUrls: ['./subscriber.component.scss']
})
export class SubscriberComponent extends Compbaser  {

    constructor(public fintechService: FintechService,
                private route: ActivatedRoute) {
        super();
        const payerToken = this.route.snapshot.paramMap.get('encrypted_id');
        this.fintechService.payerToken$ = of(payerToken);

        const obs$ = this.fintechService.getFintechInfo();
        this.cod(obs$.subscribe());
    }
}
